import { Box, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import CloseIcon from "../../../assets/images/icons/CloseIcon";
import styles from "./UnderConstructionBanner.module.scss";

const UnderConstructionBanner = () => {
	const { t } = useTranslation("translation", { keyPrefix: "UnderConstructionBanner" });
	const [isDismissed, setIsDismissed] = useState(false);

	const handleDismiss = (e: React.MouseEvent) => {
		e.stopPropagation();
		setIsDismissed(true);
	};

	if (isDismissed) return null;

	return (
		<Box className={styles.banner}>
			<Box className={styles.content}>
				<Typography component="span" className={styles.text}>
					<span className={styles.title}>{t("title")}</span>
				</Typography>
			</Box>
			<CloseIcon className={styles.closeIcon} onClick={handleDismiss} />
		</Box>
	);
};

export default observer(UnderConstructionBanner);
